<!-- poor man's pie menu -->
<script>
    import Vue from "vue";

    export default {
        name: "ActionsPanel",
        props: {
            currentPage: String,
        },
        data() {
            return {
                showMoreStuff: false,
            };
        },
        computed: {
            passButtonLabel() {
                let labels = {
                    passwords: "New Password",
                    places: "Add Place",
                    people: "Add Person",
                    notes: "Add Note",
                };
                return labels[this.currentPage];
            },
            user() {
                return this.$store.state.user;
            },
        },
        methods: {
            requestAction(actionName, params) {
                this.$emit("onAction", actionName, params);
            },
            handleAccountMenu(ev) {
                if (ev.target != this.$refs.accountMenu) {
                    this.showMoreStuff = false;
                }
            },
        },

        mounted() {
            document.addEventListener("click", this.handleAccountMenu);
        },

        beforeDestroy() {
            document.removeEventListener("click", this.handleAccountMenu);
        },
    };
</script>

<template>
    <div class="actions-container">
        <div class="actions-panel">
            <div>
                <LogoBox section="Passwords" />
            </div>

            <div class="create-container">
                <button class="btn accent" @click="requestAction('newPassword')">
                    <span class="label">
                        {{ passButtonLabel }}
                    </span>
                </button>
            </div>

            <nav>
                <button :class="{active: currentPage == 'passwords'}" @click="requestAction('showPasswords')">
                    Passwords
                </button>

                <button :class="{active: currentPage == 'places'}" @click="requestAction('showPlaces')">
                    Places
                </button>

                <button :class="{active: currentPage == 'people'}" @click="requestAction('showPeople')">
                    People
                </button>

                <button :class="{active: currentPage == 'notes'}" @click="requestAction('showNotes')">
                    Notes
                </button>
            </nav>

            <div class="expander" />

            <nav>
                <button class="account-toggle" ref="accountMenu" @click.stop="showMoreStuff = !showMoreStuff">
                    <i class="material-icons">settings</i>
                    Account&hellip;
                </button>
            </nav>
        </div>

        <div class="more-stuff" v-if="showMoreStuff">
            <button @click="requestAction('importLockbox')">
                Import from a backup
            </button>
            <button @click="requestAction('exportLockbox')">
                Download all passwords
            </button>
            <hr />
            <button @click="requestAction('changeMasterPass')">
                Change master password&hellip;
            </button>
            <hr />
            <button @click="requestAction('logOut')">
                Log Out
            </button>
        </div>
    </div>
</template>



<style lang="scss">
    .actions-container {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: fixed;
        max-width: $max-width;
        margin: 0 auto;
        top: 0;
        z-index: 500;
        pointer-events: none;

        button {
            pointer-events: all;
        }

        @media (max-width: $max-width + 15) {
            max-width: $max-width + 50;
        }

        .logo-box {
            margin: 20px 0px;
            display: inline-grid;
            font-size: 18px;

            gap: 5px 15px;

            .section {
                font-size: 12px;
            }

            svg {
                width: 55px;
            }
        }

        .create-container {
            text-align: center;
            margin: 1em 0;

            button {
                width: 11em;
            }
        }

        .actions-panel {
            position: absolute;
            top: 0;
            left: 0;
            width: $logo-width;
            bottom: 0;
            display: flex;
            flex-direction: column;

            background: #edf1ef;

            .expander {
                flex-grow: 1;
            }

            nav {
                margin-top: 1em;
                width: 100%;

                button {
                    width: 100%;
                    border-right: 3px solid transparent;

                    padding: 1.5em 32px;
                    text-align: left;
                    align-items: center;
                    font-size: 14px;

                    &:focus {
                        outline: none;
                    }

                    &.active {
                        background: #bdcccb;
                        border-right: 4px solid #6b8684;
                        font-weight: 600;

                    }

                    &.account-toggle {
                        margin: 3px;
                        display: flex;
                        align-items: center;

                        i {
                            padding-right: 10px;
                        }

                        &:hover,
                        &:focus {
                            background: none;
                        }
                    }
                }
            }
        }

        .more-stuff {
            border: 1px solid #ccc;
            box-shadow: 0px 0px 10px 0px #aaa;
            background: #fff;

            position: fixed;
            bottom: 3em;
            margin-left: 30px;
            display: flex;
            flex-direction: column;


            hr {
                border: none;
                border-bottom: 1px solid #ddd;
                width: 100%;
                margin: 0;
                padding: 0;
            }

            button {
                font-weight: 400;
                font-size: 14px;
                padding: 1em;
                text-align: left;

                &:hover {
                    background: #1967d2;
                    color: #fff;
                    text-decoration: none;
                }
            }

            .emoji {
                height: 30px;
                width: 30px;
                margin-right: 0.5em;
            }
        }
    }

    @media (max-width: $mobile-width-break) {
        .actions-container {
            display: none;
        }
    }
</style>
